import { useState } from "react";
import { ChevronDown } from "lucide-react";
import type { ArticleFAQ } from "@/types/blog";

interface FAQAccordionProps {
  items: ArticleFAQ[];
}

export function FAQAccordion({ items }: FAQAccordionProps) {
  const [openIdx, setOpenIdx] = useState<number | null>(null);

  if (!items || items.length === 0) return null;

  return (
    <div
      style={{
        margin: "var(--s-md) 0",
        border: "1px solid var(--dyna-border)",
        borderRadius: 12,
        overflow: "hidden",
        background: "var(--dyna-bg-elevated)",
      }}
    >
      {items.map((item, i) => {
        const isOpen = openIdx === i;
        return (
          <div
            key={i}
            style={{
              borderTop: i === 0 ? "none" : "1px solid var(--dyna-border)",
            }}
          >
            <button
              type="button"
              onClick={() => setOpenIdx(isOpen ? null : i)}
              aria-expanded={isOpen}
              style={{
                width: "100%",
                background: "transparent",
                border: "none",
                padding: "18px 20px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 12,
                cursor: "pointer",
                color: "var(--dyna-fg)",
                fontFamily: "Geist, system-ui, sans-serif",
                fontSize: 16,
                fontWeight: 600,
                textAlign: "start",
              }}
            >
              <span>{item.question}</span>
              <ChevronDown
                size={18}
                style={{
                  flexShrink: 0,
                  transition: "transform 200ms ease",
                  transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
                  color: "var(--lavender-400)",
                }}
              />
            </button>
            <div
              style={{
                maxHeight: isOpen ? 1000 : 0,
                overflow: "hidden",
                transition: "max-height 280ms ease",
              }}
            >
              <div
                style={{
                  padding: "0 20px 20px 20px",
                  fontFamily: "Geist, system-ui, sans-serif",
                  fontSize: 15,
                  lineHeight: 1.7,
                  color: "var(--dyna-fg-muted)",
                }}
              >
                {item.answer}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
